import React, { useState, useEffect, useRef } from 'react';
import { OverlayTrigger, Tooltip ,Spinner} from 'react-bootstrap';
import httpService from 'services/httpService.js';
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import { Button } from "react-bootstrap";
import * as constants from "Constants";
import InfiniteScroll from 'react-infinite-scroll-component';
import { TiDeleteOutline } from "react-icons/ti";
import './Multicomment.css';
import { getUser } from 'Store/UserInfo/Actions';
import { FaArrowUp } from "react-icons/fa";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import 'primereact/resources/themes/saga-blue/theme.css';  // PrimeReact theme after
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';


const Multicomment = ({submission,isStudentView}) => {
    const [comment,setComment] = useState("");
    const [commentHistory, setCommentHistory] = useState([]);
    const [hasMoreComments, setHasMoreComments] = useState(true);
    const [pageNo, setPageNo] = useState(1);
    const scrollRef = useRef();
    const textareaRef = useRef(null);
    const [hovered, setHovered] = useState(null);
    const [user,setUser] = useState(null);
    const [access_control_vars, setAccessControlVars] = useState(null);
    const [isFetching, setIsFetching] = useState(false);
    const [isResetDone, setIsResetDone] = useState(false);

    const handleSubmitComment =async () =>{
        let submissionId = submission?.id;
        let studentId = submission?.student;
        let form_data = new FormData();
        form_data.append("comment", comment);
        form_data.append("student_id", studentId);
        try {
            const url = constants.base_url + "/evalpro/grading/add_comment/" + submissionId;
            const response = await httpService.post(url, form_data);
            if(response.status === 201){
                displayGlobalMessage("Comment added successfully", "success");
                // Reset the comment input field
                setComment("");
                const new_comments = Array.isArray(response.data.data.comment_thread)? response.data.data.comment_thread : [];
                new_comments.reverse();
                if(new_comments.length < 10){
                    setHasMoreComments(false);
                }
                else{
                    setHasMoreComments(true);
                }
                setPageNo(2);
                setIsFetching(false);
                setTimeout(() => { 
                    setCommentHistory(new_comments);
                }, 500);
            }
            else{
                displayGlobalMessage(error.response.data.detail || "Undefined error", "error");
            }
        }
        catch(error){
            if(error.response && error.response.data && error.response.data.detail) {
                displayGlobalMessage(error.response.data.detail, "error");
            }
            else{
                displayGlobalMessage("Error in adding comment", "error");
            }
        }
    }

    const fetchMoreComments = async () => {
        let submissionId = submission?.id;
        let studentId = submission?.student;
        try {
            const url = constants.base_url + "/evalpro/grading/get_comment_history/" + submissionId + `?page_no=${pageNo}&page_size=10&student_id=${studentId}`;
            const response = await httpService.get(url);
            if(response.status === 200){
                setAccessControlVars(response.data.access_control_vars || null);
                const new_comments = Array.isArray(response.data.data.comment_thread)? response.data.data.comment_thread : [];
                new_comments.reverse();
                setIsFetching(true);
                setCommentHistory(prevComments => [...new_comments,...prevComments]);
                setPageNo(prevPageNo => prevPageNo + 1);
                if(new_comments.length < 10){
                    setHasMoreComments(false);
                }
                else{
                    setHasMoreComments(true);
                }
            }
            else{
                displayGlobalMessage(error.response.data.detail || "Undefined error", "error");
            }
        } catch (error) {
            if(error.response && error.response.data) {
                displayGlobalMessage(error.response.data.error_msg, "error");
                setAccessControlVars(error.response.data.access_control_flags || null);
            }else{
                displayGlobalMessage("Error in fetching comments", "error");
        
            }
        }
    }

    const handleDelete = async (commentId) => {
        let submissionId = submission?.id;
        let studentId = submission?.student;
        try {
            const url = constants.base_url + "/evalpro/grading/delete_comment/" + submissionId + `?comment_id=${commentId}&student_id=${studentId}`;
            const response = await httpService.delete(url);        
            if(response.status === 200){
                displayGlobalMessage("Comment deleted successfully", "success");
                // Reset the comment input field
                setComment("");
                const new_comments = Array.isArray(response.data.data.comment_thread)? response.data.data.comment_thread : [];
                new_comments.reverse();
                setIsFetching(false);
                setHasMoreComments(false);
                setTimeout(() => {
                    setCommentHistory(new_comments);
                }, 500);
            }
            else{
                displayGlobalMessage(error.response.data.detail || "Undefined error", "error");
            }
        }
        catch (error) {
            if(error.response && error.response.data && error.response.data.detail) {
                displayGlobalMessage(error.response.data.detail, "error");
            } 
            else{
                displayGlobalMessage("Error in deleting comment", "error");
            }
            return;
        }
    }

    const confirm = (commentId) => {
        confirmDialog({
            message: 'Do you want to delete this comment?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                handleDelete(commentId);
            },
            reject:() => {
            }
        });
    };

    useEffect(() => {
        const userData = getUser();
        if (userData) {
            setUser(userData);
        }
    }, []);

    useEffect(() => {
        if (scrollRef.current && !isFetching) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [commentHistory]);

    useEffect(() => {
        setPageNo(1);
        setCommentHistory([]);
        setHasMoreComments(true);
        setIsFetching(false);
        setIsResetDone(false);
    },[submission]);

    useEffect(() => {
    if (pageNo === 1 && commentHistory.length === 0 && !isFetching && hasMoreComments && !isResetDone) {
        setIsResetDone(true);
    }
    }, [pageNo, commentHistory, isFetching,hasMoreComments]);

    useEffect(() => {
        if(isResetDone) {
            fetchMoreComments();
            setIsResetDone(false);
        }
    }, [isResetDone]);

    const maxHeight = 150; // Set your max height in pixels

    const adjustHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = 'auto'; // Reset
            textarea.style.height = Math.min(textarea.scrollHeight, maxHeight) + 'px';
        }
    };

    useEffect(() => {
        adjustHeight();
    }, [comment]);

    return (
        <div className="comment-section">
            <ConfirmDialog />
            <div
                id="scrollableDiv"
                style={{
                    height:400,
                    overflow: 'auto',
                    display: 'flex',
                    flexDirection: 'column-reverse',
                    marginTop: '10px',
                }}
                className="pl-5 pr-5 mt-2"
                ref={scrollRef}
            >
                {
                    access_control_vars && access_control_vars.enable_display_past_comment_history ?(
                        commentHistory.length > 0 ? (
                            <InfiniteScroll
                                dataLength={commentHistory.length}
                                next={fetchMoreComments}
                                hasMore={hasMoreComments}
                                loader={<Spinner animation="border" variant="secondary" />}
                                scrollableTarget="scrollableDiv"
                                inverse={true}
                            >
                                {commentHistory.map((comment_data, index) => (
                                    <div 
                                        className="comment-box"
                                        onMouseEnter={() => setHovered(index)}
                                        onMouseLeave={() => setHovered(null)}
                                    >
                                        {
                                            (hovered === index && user?.email === comment_data.commented_by_email && !isStudentView) &&
                                            <div onClick={()=>{confirm(comment_data.id)}} className="comment-box-delete">
                                                <TiDeleteOutline />
                                            </div>
                                        }
                                        
                                        <div className="text-gray-800 text-sm" style={{wordBreak: 'break-all'}}>
                                            <strong className="font-medium text-gray-900">{comment_data.comment}</strong>
                                        </div>
                                        <div className="flex" style={{ justifyContent: "space-between" }}>
                                            <div className="text-xs text-gray-500 mt-2" style={{width:'60%'}}>
                                                {comment_data.commented_by_name + " ( " + comment_data.commented_by_email + " ) "}
                                            </div>
                                            <div className="text-right text-xs text-gray-500 pr-2 mt-2">
                                                {new Date(comment_data.commented_on).toLocaleString()}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </InfiniteScroll>
                        ):
                        <div className='comment-text'>
                            <div> No comments yet.</div>
                        </div>
                    
                    ) :
                    <div className='comment-text'>
                        <div> You are not allowed to view comments.</div>
                    </div>
                }
                
            </div>
            {
                !isStudentView && 
                <div className="flex items-center pl-5 pr-4 comment-container">
                    <textarea
                        ref={textareaRef}
                        rows={1}
                        placeholder={access_control_vars?.enable_add_comment_on_submission ? "Comment here" : "You are not allowed to add Comment"}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        className={access_control_vars?.enable_add_comment_on_submission ? "comment-textarea" : "comment-textarea comment-textarea-disabled"}
                        disabled={!access_control_vars?.enable_add_comment_on_submission}
                    />
                    <OverlayTrigger overlay={
                        <Tooltip>
                            {!access_control_vars?.enable_add_comment_on_submission 
                                ? "You are not allowed to add Comment"
                                : (comment.trim() ? "Submit Comment": "Empty Comment")}
                        </Tooltip>
                    }>
                        <Button
                            className="send-button"
                            variant="primary"
                            onClick={handleSubmitComment}
                            disabled={(!comment.trim()) || (!access_control_vars?.enable_add_comment_on_submission)}
                            aria-label="Submit comment"
                        >
                            <FaArrowUp size={18} />
                        </Button>
                    </OverlayTrigger>
                </div>
            }
        </div>
    )
}
export default Multicomment;